import _extends from "@babel/runtime-corejs3/helpers/extends";
import React, { forwardRef } from 'react';
import IconButton from './';
import TintButton from '../basic/tint';
export var TintIconButton = /*#__PURE__*/forwardRef(function TintIconButton(props, ref) {
  return /*#__PURE__*/React.createElement(IconButton, _extends({
    Button: TintButton
  }, props, {
    ref: ref
  }));
});
export default TintIconButton;